/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree, DEFAULT_SAVED_SEARCH_TREE_SORT } from '../helpers/savedSearches';

export const renameGroup = createAsyncThunk(
  'savedSearches/renameGroup',
  async (
    { path, name, isShared },
    {
      extra: { sdk, Logger, Toast },
      getState,
    },
  ) => {
    try {
      const { data: result } = await sdk.savedSearches.renameGroup(path, name, isShared);

      return { searches: result, userId: getState().user._id };
    } catch (error) {
      Logger.error(new Error('Can not rename saved search group'), { error }, [
        'RenameSavedSearchGroupFailed',
        { errorMessage: (error && error.message) || 'NoMessage' },
      ]);

      Toast('Error renaming saved search', { type: 'error' });

      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    renameGroup.fulfilled,
    (state, { payload: { searches, userId } }) => {
      const searchesById = searches.reduce((acc, ss) => {
        acc[ss._id] = ss;
        return acc;
      }, {});
      state.all = state.all.map((ss) => (searchesById[ss._id] ? searchesById[ss._id] : ss));
      state.tree = makeTree(
        state.all,
        userId,
        state.searchQuery,
        state.treeSortType || DEFAULT_SAVED_SEARCH_TREE_SORT,
      );
    },
  ).addCase(
    renameGroup.rejected,
    (state, { error }) => {
      state.error = error;
    },
  );
};
